import { ButtonLink, ToastContentProps } from "@clarkinc/zest-design-system/ui";
import React from "react";

interface CustomToastProps extends Partial<ToastContentProps> {
  body: string;
  title: string;
  imageUrl: string;
  buttonLinkUrl: string;
  buttonLinkText: string;
}
const CustomToast = ({
  body,
  title,
  imageUrl,
  buttonLinkUrl,
  buttonLinkText,
}: CustomToastProps): JSX.Element => {
  return (
    <div className="flex flex-row gap-2">
      <img
        src={imageUrl}
        alt={body}
        className="w-20 h-20 box-border p-1 rounded border border-solid border-gray-500"
        data-testid="custom-toast-image"
      />
      <div className="flex flex-col gap-2">
        {title && <p className="font-bold leading-4">{title}</p>}
        <p className="font-semibold text-xs">{body}</p>
        <div className="flex flex-row gap-3">
          <ButtonLink
            theme="wss"
            size="small"
            className="no-underline"
            href={buttonLinkUrl}
            data-testid="custom-toast-button"
          >
            {buttonLinkText}
          </ButtonLink>
        </div>
      </div>
    </div>
  );
};

export default CustomToast;
